import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as Yup from 'yup';
import config from '../../config.json'
import EditSelection from '../../components/PageEditSelection/EditSelection'
import { AUTH_CAPS, CLI_CINEMA_CLIENT_ID, FEATURES, PROGRAM_CINEMAS, PROGRAM_SELECTIONS_ITEMS, UI_PROGRAM } from '../../constants/state'
import getData from '../../functions/getData'
import toJS from '../../hoc/toJS'
import { selectionUpdateItemSettings, uiProgramSetEditSelection } from '../../actions'
import sortCinemas from '../../functions/sortCinemas';
import canEditProgram from '../../functions/canEditProgram';


const mapStateToProps = (state, ownProps) => ({
    selection: getData(state, [PROGRAM_SELECTIONS_ITEMS, ownProps.selectionId]),
    editSelectionSettings: getData(state, [UI_PROGRAM, 'editSelectionSettings']),
    editSelectionReducedSettings: getData(state, [UI_PROGRAM, 'editSelectionReducedSettings']),
    editSelectionStripeSettings: getData(state, [UI_PROGRAM, 'editSelectionStripeSettings']),
    editSelectionAutoplay: getData(state, [UI_PROGRAM, 'editSelectionAutoplay']),
    hasTrailerViews: getData(state, [FEATURES, 'has_trailer_views']),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    caps: getData(state, AUTH_CAPS)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onSaveEdit: (title, style, trailerAutoplay, cinemasFilter)  => {
        if(ownProps.selectionId) {
            dispatch(selectionUpdateItemSettings(ownProps.selectionId, title, style, trailerAutoplay, cinemasFilter))
        }
    },
    onCancelEdit: () => {
        dispatch(uiProgramSetEditSelection(false, false))
    }
})


class EditSelectionContainer extends Component {
    constructor(props) {
        super(props)

        this.onSubmit = this.onSubmit.bind(this)
    }

    getValues(arr) {
        return arr.map(item => item.id)
    }

    getInitValues(cliCinemasIdList) {
        const { title, style, trailerAutoplay, cinema, cinemasFilter } = this.props.selection

        return {
            title: title,
            style: style,
            trailerAutoplay: trailerAutoplay.toString(),
            cinema: cinema,
            cinemasFilter: cinemasFilter !== null ? cinemasFilter : cliCinemasIdList
        }
    }

    getValidationSchema() {
        const sectionSettings = config.sectionSettings
        const allStyles = _.union(sectionSettings.styleTypes, sectionSettings.stripeStyleTypes)

        return Yup.object().shape({
            title: Yup.string().required(),
            style: Yup.string().oneOf(this.getValues(allStyles)).required(),
            trailerAutoplay: Yup.string().oneOf(this.getValues(sectionSettings.autoplayTypes)).required()
        })
    }

    onSubmit(values) {
        const { onSaveEdit } = this.props 
        const { title, style, trailerAutoplay, cinemasFilter } = values

        onSaveEdit(title, style, "true" === trailerAutoplay, cinemasFilter)
    }


    render() {
        const { hasTrailerViews, clientCinemaId, cliCinemas, onCancelEdit, editSelectionSettings, editSelectionReducedSettings, editSelectionStripeSettings, editSelectionAutoplay, selectionId, caps } = this.props
        const { styleTypes, stripeStyleTypes } = config.sectionSettings
        const styleOptions = editSelectionStripeSettings ? stripeStyleTypes : editSelectionReducedSettings ? styleTypes.filter(option => !option.id.includes('Poster')) : styleTypes
        const cliCinemasIdList = sortCinemas(clientCinemaId, cliCinemas)
        const initValues = this.getInitValues(cliCinemasIdList)
        const validationSchema = this.getValidationSchema()
        const editDisabled = !canEditProgram(caps)

        return <EditSelection
            initValues={initValues}
            selectionId={selectionId}
            clientCinemaId={clientCinemaId}
            cliCinemas={cliCinemas}
            cliCinemasIdList={cliCinemasIdList}
            validationSchema={validationSchema}
            editSelectionSettings={editSelectionSettings}
            editSelectionAutoplay={hasTrailerViews && editSelectionAutoplay}
            styleOptions={styleOptions}
            hasTrailerViews={hasTrailerViews}
            editDisabled={editDisabled}
            onSubmit={this.onSubmit}
            onCancel={onCancelEdit}
        />
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(EditSelectionContainer)